export default __webpack_public_path__ + "static/media/eggstudio_1.2cb5228c.png";